import { TableBodyCell, TeamAvatar } from '@pocketlaw/tetris';
import { StyledLink } from './styled';
export function NameCell(props) {
    const { teamId, name } = props;
    return (<TableBodyCell headers="name">
      <StyledLink to={`users-teams/team/${teamId}`}>
        <TeamAvatar size="sm" title={name}/>
      </StyledLink>
    </TableBodyCell>);
}
